/*
 * Scroll to top with hack to avoid bottom sticky or fixed bar not shwon on IOS 18.
 * Example 1: bottom sticky continue button not shown in flight selection modals.
 * Example 1: bottom fixed sort and filters panel not shown in flight section.
 * This is because when programatically scroll to the top the large bottom IOS nav bar is rendered
 * but the viewport height is not syncronized. This function forces a scroll to trigger sync
 */
export const scrollToTop = () => {
  // This first scroll goes to the top. On IOS 18 opens the higher nav bar but does not update the viewport
  window.scrollTo(0, 1);
  setTimeout(() => {
    // This second scroll with the timeout updates the viewport. The short delay ensures the scroll event fires
    window.scrollTo(0, 0);
  }, 50);
};
